import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { CuaHangBillFormat } from '../models/store_stalls.model';
import { ServerResponse } from '../models/types';
import { GetLocalForageConFigService } from './getLocalForage.service';
import * as localForage from 'localforage';

@Injectable()
export class CurrencyService {
    url: any;
    constructor(
        private http: HttpClient,
        private getlocalconfig: GetLocalForageConFigService,
        @Inject('BASE_URL') baseUrl: string,
    ) {
        this.url = baseUrl;
    }    
    async getCurrency() {
    return this.http.get(this.url + 'api/Currency/getCurrencies')
            .toPromise()
            .then((result: ServerResponse) => {
                if (result[0].code === 1) {
                    const originalCurr = result[0].data['OriginalCurrency'];
                    const foreignCurr = result[0].data['ForeignCurrency'];
                    const exchangeRate = result[0].data['ExchageRate'];
                    const updatePerson = result[0].data['UpdatePerson'];
                    const updateDate = result[0].data['UpdateDate'];
                    this.getlocalconfig.getConfigLocalForage()
                        .then(async result => {
                            // tslint:disable-next-line:max-line-length
                            await localForage.setItem('_currency', JSON.stringify({
                                OriginalCurrency: originalCurr,
                                ForeignCurrency: foreignCurr,
                                ExchageRate: exchangeRate,
                                UpdatePerson: updatePerson,
                                UpdateDate: updateDate })).then();
                    });
                    return Promise.resolve(result[0].code);
                } else {
                    return Promise.reject(result[0].code);
                }
            });
        }
}


// WEBPACK FOOTER //
// ./src/app/services/currency.service.ts